
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import webstomp from "webstomp-client";
import Vue from "vue";
import {notificationService} from "@/views/service/notification.service";
import store from "@/store";

export const webSocketService = {
    connect,
    disconnect
};

let connected = false;
let stompClient;

function connect(client) {
    getWebSocketConfiguration()
        .then(config => {
            const socket = new SockJS(`${config.sockJSUrl}?subject=${client}`);
            const options = {debug: false, protocols: webstomp.VERSIONS.supportedProtocols()};
            stompClient = Stomp.over(socket, options);
            stompClient.connect(
                {},
                () => {
                    connected = true;
                    stompClient.subscribe(`/user/queue/${config.stompBrokerLocation}`, notification => {
                        store.dispatch('notification/getNotificationCountersAction');
                        Vue.prototype.$notification.new(JSON.parse(notification.body).content, {title: 'Nouvelle notification'});
                    });
                }, () => {
                    connected = false;
                }
            );
    })
}

function getWebSocketConfiguration() {
    return notificationService.getConfiguration();
}

function disconnect() {
    if (connected) {
        if (stompClient) {
            stompClient.disconnect();
        }
        connected = false;
    }
}
